import React from "react";

export const XIcon = ({
  width = "33",
  height = "32",
  color = "#000",
  opacity = "1",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 33 32"
      fill="none"
    >
      <g clip-path="url(#clip0_263_146)">
        <mask
          id="mask0_263_146"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="33"
          height="32"
        >
          <path d="M0.751953 0H32.752V32H0.751953V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_263_146)">
          <path
            d="M25.952 1.49951H30.8594L20.1394 13.7829L32.752 30.5007H22.8777L15.1382 20.3635L6.29252 30.5007H1.38052L12.8457 17.3578L0.751953 1.5018H10.8777L17.8628 10.7658L25.952 1.49951ZM24.2262 27.5567H26.9462L9.39195 4.29037H6.47538L24.2262 27.5567Z"
            fill={color}
            fillOpacity={opacity}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_263_146">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0.751953)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
